var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"mx-auto",attrs:{"lg":"4","sm":"6","xs":"12"}},[_c('v-row',[_c('p',{staticClass:"text-center"},[_vm._v("Marketing here")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }